module.exports = __webpack_public_path__ + "static/tasty-school-bus-pass-for-dog-c03781e0bb2a57d0aaa7c43c13e0d488.jpg";